module.exports = __webpack_public_path__ + "img/banner.02b0961.png";